import ewbApi from "network/ewbApi";
import { OTHER_SERVICES } from "network/endpoints";

export const getEwBillers = async () => ewbApi.get(OTHER_SERVICES.EwBillers);